import * as types from './mutation-types'

export const setEventList = function ({ commit }, { eventlist, total }) {
  commit(types.SET_EVENTLIST, eventlist)
  commit(types.SET_TOTAL, total)
}

export const setSearch = function({commit}, {search}) {
  commit(types.SET_SEARCH, search)
}

export const setDateRange = function({commit}, date_range) {
  commit(types.SET_DATE_RANGE, date_range)
}

export const setClearAll = function({commit}) {
  commit(types.SET_CLEAR_ALL);
}

export const setLoading = function({commit}, loading) {
  commit(types.SET_LOADING, loading);
}

export const setPage = function({commit}, page) {
  commit(types.SET_PAGE, page);
}

export const setMonthEvents = function({commit}, month_events) {
  commit(types.SET_MONTH_EVENTS, month_events);
}

export const setCategoryList = function({commit}, categorylist) {
  commit(types.SET_CATEGORY_LIST, categorylist);
}

export const setFilter = function({commit}, filter) {
  commit(types.SET_FILTER, filter)
}